// Module
var code = "<img src=\"/components/design/content/blank.png\" alt=\"Jabra support staff\" ng-src=\"{{::$ctrl.photo.url}}\"/>";
// Exports
module.exports = code;